import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { useTranslation } from 'react-i18next';
import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';
const NUMBER_BADGE_SIZE = 12;
const styles = StyleSheet.create({
    comment: {
        padding: 16,
        marginBottom: 8,
        backgroundColor: '#ededed',
        borderRadius: 6,
    },
    commentTitleWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 6,
    },
    numberBadge: {
        width: NUMBER_BADGE_SIZE,
        height: NUMBER_BADGE_SIZE,
        borderRadius: NUMBER_BADGE_SIZE / 2,
        backgroundColor: '#000',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 5,
    },
    numberBadgeText: Object.assign(Object.assign({}, commonStyles.fontXS), { color: '#fff', fontWeight: 'bold' }),
    commentCategory: Object.assign({}, commonStyles.fontS),
    commentTitle: Object.assign(Object.assign({}, commonStyles.fontS), { fontWeight: 'bold' }),
    commentNote: Object.assign({}, commonStyles.fontS),
    commentNumeration: Object.assign({}, commonStyles.fontS),
});
function PointBubble({ point, orderIndex, projectionIdx, width }) {
    var _a;
    const { t, i18n } = useTranslation('specification');
    const categoryLabel = ((_a = i18n === null || i18n === void 0 ? void 0 : i18n.language) === null || _a === void 0 ? void 0 : _a.startsWith('pl'))
        ? point === null || point === void 0 ? void 0 : point.componentCategoryLabelPL
        : point === null || point === void 0 ? void 0 : point.componentCategoryLabelEN;
    return (React.createElement(View, { style: [styles.comment, { width }], wrap: false },
        React.createElement(View, { style: styles.commentTitleWrapper },
            React.createElement(View, { style: styles.numberBadge },
                React.createElement(Text, { style: styles.numberBadgeText }, orderIndex + 1)),
            !!(point === null || point === void 0 ? void 0 : point.componentName) && categoryLabel && (React.createElement(Text, { style: styles.commentCategory }, `${categoryLabel} – `)),
            React.createElement(Text, { style: styles.commentTitle }, point === null || point === void 0 ? void 0 : point.componentName)),
        React.createElement(Text, { style: styles.commentNote }, point.note),
        React.createElement(Text, { style: styles.commentNumeration }, point.photo ? `${t('drawing')} ${projectionIdx}.${point.photoNumber}` : '')));
}
export default PointBubble;
